import i18n from '@i18n/index';

import type { I18nProvider } from '@refinedev/core';

/**
 * Refine i18n-провайдер на базе i18next.
 *
 * `translate` поддерживает namespace через `:` (например `auth:login.title`).
 * `getLocale` / `changeLocale` — для будущего переключения языка.
 */
export const i18nProvider: I18nProvider = {
  translate: (key: string, options) => i18n.t(key, options as Record<string, unknown> | undefined),
  getLocale: () => i18n.language,
  changeLocale: async (lang: string) => {
    await i18n.changeLanguage(lang);
  },
};
